(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name webAgro1App.AssistenteAuditoriaService
   * @description
   * # AssistenteAuditoriaService
   * Factory in the webAgro1App.
   */
  angular
    .module('webAgro1App')
    .factory('AssistenteAuditoriaService', AssistenteAuditoriaService);

  AssistenteAuditoriaService.$inject = [
    '$http'
  ];

  function AssistenteAuditoriaService($http) {
    //////////////////////////////////////////
    // Service object declaration
    const service = {
      batchInsumos: batchInsumos
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function batchInsumos(insumos) {
      const items = insumos.map((insumo) => {
        const idAplicacoes = insumo.glebas
          .filter((gleba) => gleba.selecionado)
          .map((aplicacao) => aplicacao.aplicacoes);
        return {
          auditoria_ids: _.flatten(idAplicacoes),
          insumo_new: {
            item_id: insumo.insumo.item_id,
            item_tipo: insumo.insumo.tipo_id,
            dose: insumo.insumo.dose,
            unidade_sistema: insumo.insumo.unidade.nomeSistema
          },
          insumo_old: {
            item_id: insumo.insumo_was.item_id,
            item_tipo: insumo.insumo_was.tipo_id
          }
        };
      });
      return $http.patch(`${SERVER }/v1/auditoria_aplicacoes/batch_insumos`, { batch: items });
    }
  }
}());
